const people = [
  {
    id: 1,
    image:
      "https://res.cloudinary.com/dhnkuonev/image/upload/v1671798431/my%20folder/snehaa_utbhbm.jpg",
    name: "Sneha",
    title: "",
    quote:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. ",
  },
  {
    id: 2,
    image:
      "https://res.cloudinary.com/dhnkuonev/image/upload/v1671798431/my%20folder/deb_sf19iy.jpg",
    name: "Debaditya",
    title: "Project Manager",
    quote:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. ",
  },
  {
    id: 3,
    image:
      "https://res.cloudinary.com/dhnkuonev/image/upload/v1671798430/my%20folder/jyoti_qqns8e.jpg",
    name: "Jyoti",
    title: "Product Manager",
    quote:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.",
  },
  {
    id: 4,
    image:
      "https://res.cloudinary.com/dhnkuonev/image/upload/v1671798656/my%20folder/puneet-superstar-simping_tpegln.jpg",
    name: "Puneet Superstar",
    title: "Vice President",
    quote:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.",
  },
];

export default people;
